export default ({
    control: {
        backgroundColor: '#fff',

        fontSize: 12,
        fontWeight: 'normal',
    },

    input: {
        margin: 0,
    },

    '&singleLine': {
        control: {
            display: 'inline-block',

            width: 130,
        },

        highlighter: {
            padding: 1,
            border: '2px inset transparent',
        },

        input: {
            padding: 1,

            border: '2px inset',
        },
    },

    '&multiLine': {
        control: {
            fontFamily: 'roboto',
        },

        highlighter: {
            padding: 9,
        },

        input: {
            padding: 9,
            minHeight: 100,
            outline: 0,
            border: '1px solid #d9d9d9',
            borderRadius: '4px',
        },
    },

    suggestions: {
        list: {
            backgroundColor: 'white',
            border: '1px solid rgba(0,0,0,0.15)',
            fontSize: 10,
            maxHeight: 100,
            overflow: 'auto',
        },

        item: {
            padding: '5px 15px',
            borderBottom: 'none',

            '&focused': {
                backgroundColor: '#ecf6fd',
            },
        },
    },
})


// WEBPACK FOOTER //
// ./src/components/schedule/popup/defaultStyle.js